import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Gift, Copy, Check, ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

// Compact "Refer & Earn" banner for the logged-in home pages (vendor + contractor).
export function ReferralBanner() {
  const [refs, setRefs] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    api.get("/referrals").then((r) => setRefs(r.data)).catch(() => {});
  }, []);

  if (!refs?.referral_code) return null;
  const link = `${window.location.origin}/login?ref=${refs.referral_code}`;
  const copy = () => {
    navigator.clipboard?.writeText(link);
    setCopied(true);
    toast.success("Referral link copied");
    setTimeout(() => setCopied(false), 1800);
  };

  return (
    <div data-testid="referral-banner" className="relative overflow-hidden rounded-xl border border-brand/20 bg-brand-soft/60 dark:bg-brand/10 px-4 py-3 mb-6 flex flex-col sm:flex-row sm:items-center gap-3">
      <div className="flex items-center gap-3 flex-1 min-w-0">
        <div className="w-9 h-9 rounded-lg bg-brand/15 flex items-center justify-center shrink-0">
          <Gift className="w-5 h-5 text-brand" />
        </div>
        <div className="min-w-0">
          <div className="text-sm font-semibold text-slate-900 dark:text-slate-100">Refer &amp; earn a free month</div>
          <div className="text-xs text-muted-foreground truncate">
            Your code <span className="font-mono font-bold text-foreground">{refs.referral_code}</span> — invite a vendor or contractor, you both get rewarded.
          </div>
        </div>
      </div>
      <div className="flex items-center gap-2 shrink-0">
        <button
          data-testid="referral-banner-copy"
          onClick={copy}
          className="inline-flex items-center gap-1.5 h-9 px-3 rounded-lg bg-card border border-border text-sm font-semibold hover:border-brand/40 transition-colors"
        >
          {copied ? <Check className="w-4 h-4 text-emerald-600" /> : <Copy className="w-4 h-4" />}
          {copied ? "Copied" : "Copy link"}
        </button>
        <Link
          data-testid="referral-banner-link"
          to="/referrals"
          className="inline-flex items-center gap-1 h-9 px-3 rounded-lg bg-brand text-white text-sm font-semibold hover:opacity-90 transition-opacity"
        >
          Refer &amp; Earn <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  );
}
